// src/pages/PricingPage.tsx
import React, { useEffect, useState } from 'react';
import Text from '../elements/TextComponent';
import Button from '../elements/Button';
import PayPalCheckout from './PaypalCheckout';
import { getMyBilling } from '../../api/paymentsApi';
import { BillingInfo } from '../../api/types';
import { formatIsoDate } from '../../utils/utilFunctions';

const PricingPage: React.FC = () => {
  const [billing, setBilling] = useState<BillingInfo | null>(null);
  const [loading, setLoading] = useState(true);

  // Load billing info for current user
  useEffect(() => {
    const loadBilling = async () => {
      setLoading(true);
      const { data, error } = await getMyBilling();
      if (error) {
      }
      setBilling(data);
      setLoading(false);
    };
    loadBilling();
  }, []);

  // UI when user already has active access
  const renderActiveAccess = () => {
    if (!billing) return null;
    const isSub = billing.status === 'active_subscription';
    const label = isSub ? 'Monthly Subscription' : 'Weekly Access';

    return (
      <div
        style={{
          padding: '40px',
          textAlign: 'center',
          maxWidth: '500px', // ✅ limit width for nice centered card
          margin: '0 auto',
        }}
      >
        <Text
          text={`✅ You have active ${label}`}
          fontSize="22px"
          fontWeight="600"
          lineHeight="28px"
          color="#030303"
          textAlign="center"
        />
        {label === 'Monthly Subscription' ? 
          <Text
            text={`Enjoy unlimited assistants`}
            fontSize="22px"
            fontWeight="400"
            lineHeight="28px"
            color="#030303"
            textAlign="center"
          />
        : null }
{/*         {label === 'Weekly Access' ? 
          <Text
            text={`Enjoy unlimited assistants`}
            fontSize="22px"
            fontWeight="400"
            lineHeight="28px"
            color="#030303"
            textAlign="center"
          />
        : null } */}
        <Text
          text={
            isSub
              ? `Renews on: ${formatIsoDate(billing.nextBillingAt) || '—'}`
              : `Expires on: ${formatIsoDate(billing.nextBillingAt) || formatIsoDate(billing.weeklyExpiresAt) || '—'}`
          }
          fontSize="16px"
          fontWeight="400"
          lineHeight="24px"
          color="#555"
          textAlign="center"
          style={{ marginTop: '12px' }}
        />
        {isSub && billing.manageUrl && (
          <div style={{ marginTop: '20px' }}>
            <a
              href={billing.manageUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button
                backgroundColor="var(--primary)"
                color="#ffffff"
                label="Manage Subscription"
              />
            </a>
          </div>
        )}
      </div>
    );
  };

  // UI when user needs to pick a plan (side by side, wider)
  const renderPlans = () => (
    <div
      style={{
        padding: '40px',
        display: 'flex',
        flexDirection: 'row',
        gap: '50px',
        justifyContent: 'center',
        flexWrap: 'wrap', // wrap on small screens
      }}
    >
      {/* $14 Monthly subscription */}
      <div
        style={{
          flex: '1 1 320px',
          border: '1px solid #ddd',
          borderRadius: '12px',
          padding: '32px',
          textAlign: 'center',
          boxShadow: '0 2px 10px rgba(0,0,0,0.06)',
          maxWidth: '360px', // ✅ slightly wider
        }}
      >
        <Text
          text="$14 / month"
          fontSize="22px"
          fontWeight="600"
          lineHeight="30px"
          color="#030303"
          textAlign="center"
        />
        <Text
          text="Unlimited assistants. Monthly Access. Renews automatically."
          fontSize="16px"
          fontWeight="400"
          lineHeight="24px"
          color="#555"
          textAlign="center"
          style={{ marginTop: '10px' }}
        />
        <div style={{ marginTop: '20px' }}>
          <PayPalCheckout type="subscription" />
        </div>
      </div>

      {/* $4 Weekly one-time payment */}
{/*       <div
        style={{
          flex: '1 1 320px',
          border: '1px solid #ddd',
          borderRadius: '12px',
          padding: '32px',
          textAlign: 'center',
          boxShadow: '0 2px 10px rgba(0,0,0,0.06)',
          maxWidth: '360px',
        }}
      >
        <Text
          text="$4 / 1 week"
          fontSize="22px"
          fontWeight="600"
          lineHeight="30px"
          color="#030303"
          textAlign="center"
        />
        <Text
          text="Unlimited assistants, 7 days of access. One-time payment."
          fontSize="16px"
          fontWeight="400"
          lineHeight="24px"
          color="#555"
          textAlign="center"
          style={{ marginTop: '10px' }}
        />
        <div style={{ marginTop: '20px' }}>
          <PayPalCheckout type="one-time" amount="4.00" />
        </div>
      </div> */}
    </div>
  );

  return (
    <div
      style={{
        width: '100%',
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        backgroundColor: '#f9f9f9',
        paddingTop: '60px',
        paddingBottom: '60px',
      }}
    >
      <div
        style={{
          maxWidth: '1000px', // ✅ wider overall container for plans
          width: '95%',
          background: '#fff',
          borderRadius: '12px',
          boxShadow: '0 4px 16px rgba(0,0,0,0.05)',
        }}
      >
        {loading ? (
          <Text
            text="Loading your billing info..."
            fontSize="18px"
            fontWeight="500"
            lineHeight="24px"
            color="#555"
            textAlign="center"
            style={{ padding: '60px' }}
          />
        ) : billing && billing.status !== 'none' && billing.status !== 'past_due' ? (
          renderActiveAccess()
        ) : (
          renderPlans()
        )}
      </div>
    </div>
  );
};

export default PricingPage;
